export default "__VITE_ASSET__D7YpCBd3__"